import { BallType } from 'lib_ts/enums/machine.enums';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { OnDemandRoutes } from 'lib_ts/enums/routing/routes/on-demand';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import {
  ICalibrationRebuildRequest,
  ICalibrationResetRequest,
  ILatestCalibrationRequest,
} from 'lib_ts/interfaces/on-demand/i-calibration';
import { IOnDemandMachineState } from 'lib_ts/interfaces/on-demand/i-machine-state';
import { IOnDemandSnapshot } from 'lib_ts/interfaces/on-demand/i-snapshot';
import { BaseRESTService } from 'services/_base-rest.service';

export class OnDemandService extends BaseRESTService {
  private static instance: OnDemandService;
  static getInstance(): OnDemandService {
    if (!OnDemandService.instance) {
      OnDemandService.instance = new OnDemandService();
    }

    return OnDemandService.instance;
  }

  private constructor() {
    super({
      controller: Controller.OnDemand,
    });
  }

  getLatestCalibration(payload: ILatestCalibrationRequest) {
    return this.post({ uri: OnDemandRoutes.GetLatestCalibration }, payload)
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to get latest calibration');
          return undefined;
        }

        return result.data as IOnDemandSnapshot;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  calibrationReset(payload: ICalibrationResetRequest) {
    return this.post({ uri: OnDemandRoutes.CalibrationReset }, payload)
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to reset calibration');
        }

        return result.success;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }

  calibrationRebuild(payload: ICalibrationRebuildRequest) {
    return this.post({ uri: OnDemandRoutes.CalibrationRebuild }, payload)
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to rebuild calibration');
        }

        return result.success;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }

  upsertOne(model: Partial<IOnDemandMachineState>) {
    return this.post({ uri: OnDemandRoutes.UpsertOneMs }, model)
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ?? 'Failed to upsert on-demand machine state'
          );
          return undefined;
        }

        return result.data as IOnDemandMachineState;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  findMany(payload: Partial<IOnDemandMachineState>) {
    return this.post({ uri: OnDemandRoutes.FindManyMss }, payload)
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ?? 'Failed to find many on-demand machine states'
          );
          return [];
        }

        return result.data as IOnDemandMachineState[];
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  findManyByBsHash(model: {
    machineID: string;
    ball_type: BallType;
    bs_hashes: string[];
  }) {
    return this.post({ uri: OnDemandRoutes.FindManyMssByBsHash }, model)
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ??
              'Failed to find many on-demand machine states by bs_hash'
          );
          return [];
        }

        return result.data as IOnDemandMachineState[];
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
